// SignalPulseLine — a thin track with a bright segment sweeping through
// it on a slow loop. Small, futuristic flourish for sections that were
// simplified down to just copy (no cards/steps) but still need a bit of
// motion. Color is passed in so different sections/pages can use their
// own signal color.
export function SignalPulseLine({
  colorClass = "bg-signalCobalt",
  trackClass = "bg-ink/10",
  className = "",
}) {
  return (
    <div
      className={`relative h-px w-full overflow-hidden ${trackClass} ${className}`}
      aria-hidden="true"
      data-testid="signal-pulse-line"
    >
      <span className={`signal-sweep absolute top-0 left-0 h-px w-1/3 ${colorClass}`} />
    </div>
  );
}
